<template>
  <div>
    <p>{{ $t('■ 산업안전보건법 시행규칙 [별지 제1호의2(1)서식]') }}</p>
    <h1>{{ $t('안전관리자ㆍ보건관리자ㆍ산업보건의 선임 등 보고서') }}</h1>

    <!-- ========================================================================================================== -->
    <!-- ================================================= Ⅰ.사업체 ================================================ -->
    <!-- ========================================================================================================== -->
    <table class="print-container table-1">
      <colgroup>
        <col width="80" />
      </colgroup>
      <tr>
        <td rowspan="9" class="head">{{ $t('사업체') }}</td>
        <td colspan="10" class="font-medium">{{ $t('사업장명') }}<br />
          <p class="font-normal">{{ form.inputA_1 }}</p>
        </td>
        <td colspan="14" class="font-medium">{{ $t('업종 또는 주요생산품명') }}<br />
          <p class="font-normal">{{ form.inputA_2 }}</p>
        </td>
      </tr>
      <tr>
        <td colspan="24" class="font-medium">{{ $t('소재지') }}<br />
          <p class="font-normal">{{ form.inputA_3 }}</p>
        </td>
      </tr>
      <tr>
        <td colspan="10" class="font-medium">{{ $t('근로자수') }}<br />
          <p class="font-normal" style="text-align: end">총 {{ form.inputA_6 }} 명 (남 {{ form.inputA_4 }}명 / 여 {{ form.inputA_5 }}명 )</p>
        </td>
        <td colspan="14" class="font-medium">{{ $t('전화번호') }}<br />
          <p class="font-normal">{{ form.inputA_7 }}</p>
        </td>
      </tr>
    </table>
    <!-- ========================================================================================================== -->
    <!-- ============================================== 관리자 ===================================================== -->
    <!-- ========================================================================================================== -->
    <table class="print-container table-1 mt-2" v-for="target in form.targetList">
      <colgroup>
        <col width="80" />
      </colgroup>
      <tr>
        <td rowspan="11" class="head">{{ target.title }}</td>
        <td colspan="3" class="font-medium">{{ $t('성명') }}</td>
        <td colspan="9" class="data">{{ target.data.name }}</td>
        <td colspan="3" class="font-medium">{{ $t('기관명') }}</td>
        <td colspan="9" class="data">{{ target.data.company }}</td>
      </tr>
      <tr>
        <td colspan="3" class="font-medium">{{ $t('전자우편 주소') }}</td>
        <td colspan="9" class="data">{{ target.data.email }}</td>
        <td colspan="3" class="font-medium">{{ $t('전화번호') }}</td>
        <td colspan="9" class="data">{{ target.data.phone }}</td>
      </tr>
      <tr>
        <td colspan="3" class="font-medium">{{ $t('자격/면허번호') }}</td>
        <td colspan="21" class="data">{{ target.data.licenseCode }}</td>
      </tr>

      <!--      -->
      <tr>
        <td rowspan="3" colspan="3" class="font-medium" style="border-right: 1px solid #cdcdcd; text-align: center">{{ $t('경력') }}</td>
        <td colspan="9" style="text-align: center">{{ $t('기관명') }}</td>
        <td colspan="12" style="text-align: center">{{ $t('기간') }}</td>
      </tr>
      <tr v-if="target.data.list[0]">
        <td colspan="9" style="text-align: center">{{ target.data.list[0].input1 }}</td>
        <td colspan="12" style="text-align: center">{{ target.data.list[0].input2.sDate }} ~ {{ target.data.list[0].input2.eDate }}</td>
      </tr>
      <tr v-if="target.data.list[1]">
        <td colspan="9" style="text-align: center">{{ target.data.list[1].input1 }}</td>
        <td colspan="12" style="text-align: center">{{ target.data.list[1].input2.sDate }} ~ {{ target.data.list[1].input2.eDate }}</td>
      </tr>
      <!--      -->

      <tr>
        <td rowspan="2" colspan="3" class="font-medium" style="border-right: 1px solid #cdcdcd; text-align: center">{{ $t('학력') }}</td>
        <td colspan="9" style="text-align: center">{{ $t('학교') }}</td>
        <td colspan="12" style="text-align: center">{{ $t('학과') }}</td>
      </tr>
      <tr>
        <td colspan="9" style="text-align: center">{{ target.data.educationLevel }}</td>
        <td colspan="12" style="text-align: center">{{ target.data.major }}</td>
      </tr>
      <tr>
        <td colspan="3" class="font-medium">{{ $t('선임 등 연ㆍ월ㆍ일') }}</td>
        <td colspan="21" class="data">{{ target.data.assignmentDate }}</td>
      </tr>
      <tr>
        <td colspan="3" class="font-medium">{{ $t('전담·겸임구분') }}</td>
        <td colspan="21" class="data">{{ target.data.type }}</td>
      </tr>
    </table>

    <p class="mt-8 ml-4">{{ $t('「산업안전보건법 시행규칙」 제14조제2항에 따라 위와 같이 보고서를 제출합니다.') }}</p>
    <div class="flex items-center justify-end">
      <span style="text-align: right">{{ form.stdInfo.date | moment("YYYY") }}</span
      ><span style="margin-left: 10px">년</span> <span style="width: 90px; text-align: right">{{ form.stdInfo.date | moment("MM") }}</span
      ><span style="margin-left: 10px">월</span> <span style="width: 90px; text-align: right">{{ form.stdInfo.date | moment("DD") }}</span
      ><span style="margin-left: 10px">일</span>
    </div>
    <div class="mt-2 flex items-center justify-end">
      <span class="font-medium" style="text-align: right">{{ $t('보고인(사업주 또는 대표자)') }}</span>
      <span style="margin-left: 10px">{{ form.inputB_1 }}</span>
      <img v-if="form.inputB_2" :src="form.inputB_2" width="20%" alt="Signature" class="signatureImg" />
      <span style="margin-left: 10px">{{ $t('(서명 또는 인)') }}</span>
    </div>
    <div class="flex items-center justify-start">
      <h4 class="ml-8">{{ $t('지방고용노동청(지청)장') }}</h4>
      <p>{{ $t('귀하') }}</p>
    </div>

    <div class="w-full" style="border-top: 2px solid #777777; padding: 2px 8px"></div>
    <div class="w-full text-center" style="border-top: 2px solid #777777; padding: 11px 8px; background-color: #c8c8c8">{{ $t('공지사항') }}</div>
    <div class="w-full text-center" style="border-top: 1px solid #777777; border-bottom: 1px solid #777777; padding: 4px 11px">{{ $t('본 민원의 처리결과에 대한 만족도 조사 및 관련 제도 개선에 필요한 의견조사를 위해 귀하의 전화번호(휴대전화)로 전화조사를 실시할 수 있습니다.') }}</div>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    form: Object,
  },
};
</script>

<style lang="scss" scoped>
* {
  font-size: 13px;
}
h1 {
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  text-align: center;
  padding: 20px 0px;
}

h4 {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 35px;
}

.before-label {
  display: list-item;
  list-style-type: "·";
  padding-left: 6px;
  margin-left: 6px;
}

table.table-1 {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-top: 2px solid #cdcdcd;
  border-bottom: 2px solid #cdcdcd;

  td {
    border: 1px solid #cdcdcd;
    border-right: 0;
    padding: 4px 8px;
    word-break: keep-all;

    box-sizing: border-box !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;

    &.gray {
      background: #f0f0f0;
    }
    &.head {
      text-align: center;
      font-weight: 500;
      background: #f0f0f0;
      border-left: 0 !important;
    }
    &.data {
      border-left: 0 !important;
    }
  }
}
table.table-2 {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  td {
    padding: 4px 8px;
    word-break: keep-all;

    box-sizing: border-box !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;

    &.gray {
      background: #f0f0f0;
    }
    &.head {
      text-align: center;
      font-weight: 500;
      background: #f0f0f0;
      border-left: 0 !important;
    }
    &.data {
      border-left: 0 !important;
    }
  }
}

table.table-3 {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-top: 4px solid #cdcdcd;
  border-bottom: 2px solid #cdcdcd;

  td {
    border: 1px solid #cdcdcd;
    border-right: 0;
    padding: 4px 8px;
    word-break: keep-all;

    box-sizing: border-box !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;

    &.gray {
      background: #f0f0f0;
    }
    &.head {
      text-align: center;
      font-weight: 500;
      background: #f0f0f0;
      border-left: 0 !important;
    }
    &.data {
      border-left: 0 !important;
    }
  }
}
td > div.print-textarea {
  min-height: 0;
  text-align: left !important;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
